import { useQuery } from '@tanstack/react-query'
import { dataSource } from '../../service/domain/_service.config'

export const ANNOUNCEMENTS_QUERY_KEY = (challengeID?: string) =>
  ['announcements', challengeID ?? 'all'] as const

export default function useAnnouncements(challengeID?: string) {
  return useQuery({
    queryKey: ANNOUNCEMENTS_QUERY_KEY(challengeID),
    queryFn: () => dataSource.getAnnouncements(challengeID),
    enabled: !!challengeID,
  })
}
